export default "__VITE_ASSET__Cy5XKjkg__"